import { NotFoundError } from "@/modules/errors";
import { transactionsQuery } from "@/services/lukita/queries";
import getAccount from "./get-account";

export default async function getTransactions({
  slug,
  first,
  skip,
  sort,
  from,
  channel,
}) {
  return getAccount()
    .then((account) =>
      transactionsQuery({
        slug,
        accountId: account?.id,
        first,
        skip,
        sort: sort ? [sort] : ["date_DESC"],
        from,
        channel,
      }),
    )
    .then(({ project }) => {
      if (!project) throw new NotFoundError();
      return project;
    });
}
